import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EquipmentAlert from '../equipmentAlert';
import EquipmentOwnerDetails from '../equipmentOwnerDetails';
import EquipmentInformation from '../equipmentInformation';
import ReadableParameterList from '../readableParameterList';
import WritableParameterList from '../writableParameterList';
import { useHook as equipmentInfo } from '../useHook';
import { useSelector } from 'react-redux';
interface ChildComponentProps {
  setRefreshFunction: (handleRefreshClick: () => void) => void;
}
const SharedWithMeEquimentDetails: React.FC<ChildComponentProps> = ({
  setRefreshFunction,
}) => {
  const { fetchGetEquipmentDetails } = equipmentInfo();
  const { customerEquipmentDetails } = useSelector(
    (state: any) => state.equipmetInfo,
  );
  const { id } = useParams();
  const [refreshKey, setRefreshKey] = useState(0);

  const getEquipmentDetails = async () => {
    const payload = {
      unitID: id,
    };
    await fetchGetEquipmentDetails(payload);
  };

  useEffect(() => {
    getEquipmentDetails();
    sessionStorage.removeItem('paramPayload');
  }, []);

  let childRefreshFunction: () => void;

  const setChildRefreshFunction = (refreshFunc: () => void) => {
    childRefreshFunction = refreshFunc;
  };

  const handleRefreshClick = () => {
    if (childRefreshFunction) {
      childRefreshFunction(); // Trigger the child component's refresh function
    }
    getEquipmentDetails();
    setRefreshKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    setRefreshFunction(handleRefreshClick);
  }, [setRefreshFunction]);

  return (
    <>
      <EquipmentOwnerDetails equipmentDetailsData={customerEquipmentDetails} />

      <EquipmentInformation
        equipmentDetailsData={customerEquipmentDetails}
        equipmentPage="sharedwithme"
      />

      <ReadableParameterList
        equipmentDetailsData={customerEquipmentDetails}
        setRefreshFunction={setChildRefreshFunction}
      />

      <WritableParameterList
        equipmentDetailsData={customerEquipmentDetails}
        equipmentPage="sharedwithme"
        refreshKey={refreshKey}
      />

      <EquipmentAlert
        equipmentDetailsData={customerEquipmentDetails}
        refreshKey={refreshKey}
      />
    </>
  );
};

export default SharedWithMeEquimentDetails;
